import { LaserProfileFormData } from "@/types/laserProfile";

const mapLaserProfiles = (profiles: any[]): LaserProfileFormData[] => {
	return profiles.map((profile): LaserProfileFormData => {
		const laserProfile = profile?.laser_properties || profile;

		return {
			id: profile.id,
			laser_properties_id: laserProfile.id,

			name: profile.name,
			description: profile.description,

			wobble_thickness: laserProfile.wobble_thickness.toString(),
			wobble_overlap_percentage: laserProfile.wobble_overlap_percentage.toString(),

			power: laserProfile.power.toString(),
			jump_speed: laserProfile.jump_speed.toString(),
			jump_delay: laserProfile.jump_delay.toString(),

			marking_speed: laserProfile.marking_speed.toString(),
			mark_delay: laserProfile.mark_delay.toString(),

			laser_on_delay: laserProfile.laser_on_delay.toString(),
			laser_off_delay: laserProfile.laser_off_delay.toString(),
			poly_delay: laserProfile.poly_delay.toString(),
			pipeline_delay: laserProfile.pipeline_delay.toString(),

			modulation_frequency: laserProfile.modulation_frequency.toString(),
			repeat_count: laserProfile.repeat_count.toString(),
			pulse_waveform: laserProfile.pulse_waveform.toString(),

			velocity_compensation_mode: { value: laserProfile.velocity_compensation_mode },
			velocity_compensation_limit: laserProfile.velocity_compensation_limit.toString(),
			velocity_compensation_aggressiveness: laserProfile.velocity_compensation_aggressiveness.toString(),

			max_radial_error: laserProfile.max_radial_error.toString(),
			break_angle: laserProfile.break_angle.toString(),

			duty_cycle_one: laserProfile.duty_cycle_one.toString(),
			duty_cycle_two: laserProfile.duty_cycle_two.toString(),
		};
	});
};

export default mapLaserProfiles;